export class RandomColor {
    static Next() {
        return "#0000FF";
        // const names = {
        //     black: "#000000",
        //     blue: "#0000ff",
        //     brown: "#a52a2a",
        //     cyan: "#00ffff",
        //     darkblue: "#00008b",
        //     darkcyan: "#008b8b",
        //     darkgrey: "#a9a9a9",
        //     darkgreen: "#006400",
        //     darkmagenta: "#8b008b",
        //     darkolivegreen: "#556b2f",
        //     darkorange: "#ff8c00",
        //     darkorchid: "#9932cc",
        //     darkred: "#8b0000",
        //     darksalmon: "#e9967a",
        //     darkviolet: "#9400d3",
        //     fuchsia: "#ff00ff",
        //     gold: "#ffd700",
        //     green: "#008000",
        //     indigo: "#4b0082",
        //     khaki: "#f0e68c",
        //     lime: "#00ff00",
        //     magenta: "#ff00ff",
        //     maroon: "#800000",
        //     navy: "#000080",
        //     olive: "#808000",
        //     orange: "#ffa500",
        //     purple: "#800080",
        //     violet: "#800080",
        //     red: "#ff0000",
        //     silver: "#c0c0c0",
        //     yellow: "#ffff00"
        // };
        // const namesArray: {name: string, value: string }[] = [];
        // Object.entries(names).forEach(prop => {
        //     namesArray.push({ name: prop[0], value: prop[1]});
        // });
        // const ran = Math.floor(Math.random() * namesArray.length);
        // return namesArray[ran].value;
    }
}
